import { MediaAnalysisHistoryCondition } from '@/common/api/modules/mediaAnalysis'
import { AnalysisHistoryListItem } from '@/common/api/params/mediaAnalysis'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import MediaAnalysisHistoryListRow from '@/components/container/modules/media/analysisHistory/table/MediaAnalysisHistoryListRow'
import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const HEADERS = ['実行日時', 'ID', '分析名', '分類', '状態', '実行方法', '生成アクション']

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      {HEADERS.map((label, index) => (
        <TableHeadItem key={index} type='thin' float={float} {...rectProps(index)}>
          {label && (
            <Text size={12} color={TextColor.SECONDARY}>
              {label}
            </Text>
          )}
        </TableHeadItem>
      ))}
    </>
  )
}

interface Props {
  siteId: number
  items: AnalysisHistoryListItem[]
  total: number
  condition: MediaAnalysisHistoryCondition
  onUpdatePage(page: number): void
}

const HISTORY_COLUMN_LENGTH = 7

const MediaAnalysisHistoryListTable = ({
  siteId,
  items,
  total,
  condition,
  onUpdatePage
}: Props) => {
  const listFollowProps = useListScrollFollow(HISTORY_COLUMN_LENGTH)
  const { header } = listFollowProps

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...header} />}
      tableFloatHead={<Thead {...header} float />}
      body={
        <>
          {items.map((item) => (
            <MediaAnalysisHistoryListRow key={item.id} siteId={siteId} item={item} />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default MediaAnalysisHistoryListTable
